export class SocketDto {
    constructor(
        public host: string,
        public path: string,
    ) { }
}